import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UiBlockerService } from '../ui-blocker.service';

@Component({
  selector: 'lib-ui-blocker-overlay',
  templateUrl: './ui-blocker-overlay.component.html',
  styleUrls: ['./ui-blocker-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class UiBlockerOverlayComponent {
  private readonly blocker = inject(UiBlockerService);
  readonly blocked = this.blocker.blocked;
}
